import React from 'react';
import { colors } from '../../styles/colors';

/**
 * ChartCard - Container de graphique avec titre + icône + contenu
 *
 * Wrapper standardisé pour les graphiques Recharts.
 * Supporte un message vide optionnel si pas de données.
 *
 * @param {Object} props
 * @param {Component} props.icon - Composant icône Lucide
 * @param {string} props.title - Titre de la carte
 * @param {ReactNode} props.children - Contenu du graphique (ResponsiveContainer)
 * @param {number} [props.iconSize=22] - Taille de l'icône
 * @param {string} [props.emptyMessage] - Message si pas de données (optionnel)
 */
function ChartCard({
  icon: Icon,
  title,
  children,
  iconSize = 22,
  emptyMessage
}) {
  // Vérifier si children existe pour afficher le message vide
  const isEmpty = emptyMessage && !children;

  return (
    <div style={{
      backgroundColor: colors.background.lightBlue,
      borderRadius: '0.5rem',
      boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)',
      padding: '1.5rem',
      position: 'relative'
    }}>
      <h2 style={{
        fontFamily: '"Century Gothic Bold", "Noto Sans", sans-serif',
        fontSize: '1.125rem',
        fontWeight: 'bold',
        color: colors.primary.teal,
        marginBottom: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem'
      }}>
        <Icon size={iconSize} />
        {title}
      </h2>

      {isEmpty ? (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 300,
          color: colors.text.secondary,
          fontSize: '0.9375rem',
          fontFamily: '"Noto Sans", sans-serif'
        }}>
          {emptyMessage}
        </div>
      ) : (
        children
      )}
    </div>
  );
}

export default ChartCard;
